import En from './en'
import It from './it'

const flags = {
    it: It,
    en: En,
}
export default flags
